import { render } from "./PhoneNumberForm.vue?vue&type=template&id=e60c149c&scoped=true"
import script from "./PhoneNumberForm.vue?vue&type=script&lang=js"
export * from "./PhoneNumberForm.vue?vue&type=script&lang=js"

import "./PhoneNumberForm.vue?vue&type=style&index=0&id=e60c149c&scoped=true&lang=css"

import exportComponent from "C:\\Users\\JOnuigbo\\mgs2\\RabbitsfootOperatorApps\\playerpanel\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e60c149c"]])

export default __exports__